import { useEffect, useState } from "react";
import axios from "axios";
import { env } from "../config";
import { useParams } from "react-router-dom";
import Categories from "../components/Categories";
import PostsMap from "../components/PostsMap";
import PassiveCategoryMap from "../components/PassiveCategoryMap";

const PostsByCategoorie = () => {
  const params = useParams();
  const { key } = params;
  const [category, setCategory] = useState(null);
  const [mapCategorySlug, setMapCategorySlug] = useState(null);
  const [posts, setPosts] = useState([]);
  const [pageData, setPageData] = useState({
    current_page: 0,
    last_page: 0,
    total: 0,
  });

  const handlePageChange = (page) => {
    if (
      page !== pageData.current_page &&
      page > 0 &&
      page <= pageData.last_page
    ) {
      setPageData((prevState) => ({
        ...prevState,
        current_page: page,
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (!key) return; // wait until key is available

    axios
      .get(`${env.baseUrl}/api/posts/${key}?page=${pageData.current_page || 1}`)
      .then((response) => {
        setCategory(response.data.category);
        setMapCategorySlug(response.data.map_category_slug || null);
        const postList =
          response.data.posts?.data ||
          response.data.posts ||
          response.data.data ||
          [];
        const pageInfo = response.data.posts || response.data || {};

        setPosts(postList);
        setPageData({
          current_page: pageInfo.current_page || 1,
          last_page: pageInfo.last_page || 1,
          total: pageInfo.total || (response.data.count || postList.length),
        });
      })
      .catch((error) => console.error("Error fetching posts:", error));
  }, [key, pageData.current_page]);

  return (
    <div>
      <section className="inner-banner">
        <div className="container">
          <div className="text-block">
            <h3>
              <em>Category</em>
            </h3>
            <h1>{category}</h1>
          </div>
        </div>
      </section>
      <section className="thisweek event-category">
        <div className="container">
          <div className="lt-panel">
            <Categories type="posts" direction="vertical" activeItem={key} />
          </div>
          <div className="rt-panel">
            <div className="post-block">
              <div className="d-block d-lg-block d-md-none">
                <div className="row">
                  {posts.map((post) => (
                    <div className="col-lg-4" key={post.id}>
                      <div className="post-box">
                        <div className="post-image position-relative">
                          <div className="img-block">
                            <figure className="thumbnail zoom-effect">
                              <a href={`/post/${post.slug}`}>
                                <img
                                  src={post.image || "/images/noimgpost.jpeg"}
                                  alt={post.title}
                                  onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = "/images/noimgpost.jpeg";
                                  }}
                                />
                              </a>
                            </figure>
                            <div className="bordered-effect">
                              <a
                                href={`/post/${post.slug}`}
                                aria-label={post.title}
                              ></a>
                            </div>
                          </div>
                          <div className="post-content">
                            <div className="post-title">
                              <h2>
                                <a href={`/post/${post.slug}`}>{post.title}</a>
                              </h2>
                            </div>
                            <div className="post-category">
                              {post.category_id}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="d-block d-md-block d-lg-none">
                <div className="row">
                  {posts.map((post) => (
                    <div className="col-sm-6" key={post.id}>
                      <div className="post-box">
                        <div className="post-image position-relative">
                          <div className="img-block">
                            <figure className="thumbnail zoom-effect">
                              <a href={`/post/${post.slug}`}>
                                <img
                                  src={post.image || "/images/noimgpost.jpeg"}
                                  alt={post.title}
                                  onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = "/images/noimgpost.jpeg";
                                  }}
                                />
                              </a>
                            </figure>
                            <div className="bordered-effect">
                              <a
                                href={`/post/${post.slug}`}
                                aria-label={post.title}
                              ></a>
                            </div>
                          </div>
                          <div className="post-content">
                            <div className="post-title">
                              <h2>
                                <a href={`/post/${post.slug}`}>{post.title}</a>
                              </h2>
                            </div>
                            <div className="post-category">
                              {post.category_id}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="d-block d-xs-none d-md-none">
                <div className="row">
                  {posts.map((post) => (
                    <div className="col-xs-12" key={post.id}>
                      <div className="post-box">
                        <div className="post-image position-relative">
                          <div className="img-block">
                            <figure className="thumbnail zoom-effect">
                              <a href={`/post/${post.slug}`}>
                                <img
                                  src={post.image || "/images/noimgpost.jpeg"}
                                  alt={post.title}
                                  onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = "/images/noimgpost.jpeg";
                                  }}
                                />
                              </a>
                            </figure>
                            <div className="bordered-effect">
                              <a
                                href={`/post/${post.slug}`}
                                aria-label={post.title}
                              ></a>
                            </div>
                          </div>
                          <div className="post-content">
                            <div className="post-title">
                              <h2>
                                <a href={`/post/${post.slug}`}>{post.title}</a>
                              </h2>
                            </div>
                            <div className="post-category">
                              {post.category_id}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {pageData.last_page > 1 && (
                <nav className="post-pagination" aria-label="post navigation">
                  <ul className="pagination">
                    {/* Previous Button */}
                    <li
                      className={`page-item ${
                        pageData.current_page === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        type="button"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(pageData.current_page - 1);
                        }}
                      >
                        &laquo; Previous
                      </button>
                    </li>

                    {/* Page Number Buttons */}
                    {[...Array(pageData.last_page)].map((_, index) => {
                      const pageNumber = index + 1;
                      return (
                        <li
                          key={pageNumber}
                          className={`page-item ${
                            pageNumber === pageData.current_page ? "active" : ""
                          }`}
                        >
                          <button
                            type="button"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(pageNumber);
                            }}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      );
                    })}

                    {/* Next Button */}
                    <li
                      className={`page-item ${
                        pageData.current_page === pageData.last_page
                          ? "disabled"
                          : ""
                      }`}
                    >
                      <button
                        type="button"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(pageData.current_page + 1);
                        }}
                      >
                        Next &raquo;
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
          <div className="clearfix" />
        </div>
      </section>
      <section className="passive-map">
        <div className="container">
          {mapCategorySlug ? (
            <PassiveCategoryMap
              mapSlug={mapCategorySlug}
              eventSlug={key}
              guideSlug={mapCategorySlug}
            />
          ) : (
            <PostsMap posts={posts} />
          )}
        </div>
      </section>
    </div>
  );
};

export default PostsByCategoorie;
